export default "__VITE_ASSET__BfH$lJyU__"